import { t } from '../i18n/index.js';

/** Motorsport start gantry for the race countdown: one red pod lights per
 * second, every pod flips green on GO, and the numeral punches in each tick. */
const POD_COUNT = 3;

export function renderStartLights(element: HTMLElement, state: number | 'go'): void {
  if (!element.querySelector('.start-lights')) {
    element.innerHTML = `<div class="start-lights" aria-hidden="true">${'<i></i>'.repeat(POD_COUNT)}</div><b class="countdown-num"></b>`;
  }
  const lit = state === 'go' ? POD_COUNT : Math.min(POD_COUNT, Math.max(0, POD_COUNT + 1 - state));
  element.querySelectorAll('.start-lights i').forEach((pod, index) => pod.classList.toggle('lit', index < lit));
  const label = state === 'go' ? t('GO') : String(state);
  const numeral = element.querySelector<HTMLElement>('.countdown-num');
  if (!numeral || numeral.textContent === label) return;
  numeral.textContent = label;
  // Restart the punch-in animation on every new numeral.
  numeral.classList.remove('pop');
  void numeral.offsetWidth;
  numeral.classList.add('pop');
}
